import { Link } from "react-router-dom";
import { Trophy, TrendingUp, Landmark, Cpu, Music, Sparkles } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const ICONS = {
    trophy: Trophy,
    "trending-up": TrendingUp,
    landmark: Landmark,
    cpu: Cpu,
    music: Music,
    sparkles: Sparkles,
};

export default function CategoryCard({ category, size = "md" }) {
    const { lang } = useI18n();
    const Icon = ICONS[category.icon] || Sparkles;
    const name = lang === "en" && category.name_en ? category.name_en : category.name;
    return (
        <Link
            to={`/mercados?categoria=${category.slug}`}
            data-testid={`category-card-${category.slug}`}
            className={`group relative overflow-hidden rounded-2xl border border-p2w-line bg-p2w-surface hover:border-p2w-green/40 transition-all duration-300 hover:-translate-y-1 ${
                size === "lg" ? "h-56" : "h-40"
            }`}
        >
            {category.image_url && (
                <>
                    <img
                        src={category.image_url}
                        alt={name}
                        className="absolute inset-0 w-full h-full object-cover opacity-25 group-hover:opacity-40 group-hover:scale-105 transition-all duration-500"
                        loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-p2w-surface via-p2w-surface/70 to-transparent" />
                </>
            )}
            <div className="relative h-full flex flex-col justify-between p-5">
                <div
                    className="w-11 h-11 rounded-xl flex items-center justify-center border"
                    style={{
                        backgroundColor: `${category.color}15`,
                        borderColor: `${category.color}50`,
                        boxShadow: `0 0 24px ${category.color}25`,
                    }}
                >
                    <Icon className="w-5 h-5" style={{ color: category.color }} />
                </div>
                <div>
                    <h3 className="font-sora font-bold text-xl text-white group-hover:text-p2w-green transition-colors">
                        {name}
                    </h3>
                    <div className="mt-1 text-xs text-p2w-gray group-hover:text-white/70 transition-colors">
                        Explorar →
                    </div>
                </div>
            </div>
        </Link>
    );
}
